/** Pure display helpers of the operator birthdays page (testable without React). */
import { businessDate, toJalali } from '@sakhtar/calendar';
import { faDigits } from '../../lib/faDigits.ts';

const JALALI_MONTH_NAMES = [
  'فروردین',
  'اردیبهشت',
  'خرداد',
  'تیر',
  'مرداد',
  'شهریور',
  'مهر',
  'آبان',
  'آذر',
  'دی',
  'بهمن',
  'اسفند',
] as const;

/** «امروز» / «فردا» / «۵ روز دیگر». */
export function untilLabel(daysUntil: number): string {
  if (daysUntil === 0) return 'امروز';
  if (daysUntil === 1) return 'فردا';
  return `${faDigits(daysUntil)} روز دیگر`;
}

/** The birthday itself on the Jalali calendar: «۱۵ شهریور». */
export function birthdayDayMonth(birthdate: string): string {
  const { jm, jd } = toJalali(businessDate(birthdate));
  return `${faDigits(jd)} ${JALALI_MONTH_NAMES[jm - 1] ?? ''}`;
}
